export const APP_CONFIG_DEFAULTS = {
    supportsChatInput: true,
    supportsAudioInput: true,
    supportsVideoInput: true,
    supportsScreenShare: true,
    isPreConnectBufferEnabled: true,
};
